import React from "react";
import moment from "moment";
import "./entityViewer.scss";

export default function HeaderComponent(props) {
  let template = props.template ?? "template1";
  let profileAdapter = props.core.make("oxzion/profile");
  let fileHeaderName = props.fileData.title ? props.fileData.title : props.fileData.name ? props.fileData.name : props.proc.metadata.name;
  return (
    <div className="task-header">
      <div className="task-header-icon">
        {props.entityDetails?.entity_icon ? (
          <i className={props.entityDetails?.entity_icon}></i>
        ) :
          fileHeaderName
            ?.trim()
            ?.split(" ")
            ?.slice(0, 2)
            ?.map((v) => v?.[0]?.toUpperCase())
            ?.join("")
        }
      </div>
      <div className="task-header-info width-100">
        <div className="task-header-name" title={fileHeaderName}>
          {fileHeaderName}
        </div>
        {template === "template1" && (
          <div className="task-header-details">
            {props.fileData?.status &&
              <div>
                <p className="sub-label">Status:</p>
                <span
                  className="task-status"
                  style={{
                    backgroundColor: ["completed", "approved", "closed"].includes(props.fileData.status.toLowerCase())
                      ? "#A3C53A"
                      : props.fileData.status.toLowerCase() === "in progress"
                        ? "#F3BA1D"
                        : ["delayed", "not approved", "rejected", "not completed"].includes(props.fileData.status.toLowerCase())
                          ? "#EE4424"
                          : "#3FB5E1",
                  }}
                ></span>
                <p className="sub-value">{props.fileData.status}</p>
              </div>
            }
            {props.fileData?.start_date &&
              <div>
                <p className="sub-label">Start Date:</p>
                <p className="sub-value" title={props.fileData.start_date}>
                  {moment(props.fileData.start_date).format("YYYY-MM-DD")}
                </p>
              </div>
            }
            {props.fileData?.end_date &&
              <div>
                <p className="sub-label">Due On:</p>
                <p className="sub-value" title={props.fileData.end_date}>
                  {moment(props.fileData.end_date).format("YYYY-MM-DD")}
                </p>
              </div>
            }
            {props.fileData?.assigned_to &&
              <div>
                <p className="sub-label">Assigned To:</p>
                <div
                  onClick={(event) => profileAdapter.showProfileInfo(event, props.fileData.assigned_to)}
                  title={props.fileData.assignedToName ?? ""}
                  className="user-img"
                  style={{
                    background: `url(${props.core?.config("wrapper.url") + "user/profile/" + props.fileData.assigned_to})`,
                    backgroundSize: "contain",
                  }}
                ></div>
              </div>
            }
            {props.fileData?.created_by &&
              <div>
                <p className="sub-label">Created by:</p>
                <div
                  onClick={(event) => profileAdapter.showProfileInfo(event, props.fileData.created_by)}
                  title={props.fileData.createdByName ?? ""}
                  className="user-img"
                  style={{ background: `url(${props.core?.config("wrapper.url") + "user/profile/" + props.fileData.created_by})`, backgroundSize: "contain" }}
                ></div>
              </div>
            }
          </div>
        )}
      </div>
    </div>
  );
}
